import { z } from 'zod'

// V1 API Response Schema
export const subscribeProtectionResponseSchema = z.object({
  resultCd: z.string(),
  resultMsg: z.string().optional(),
  result: z.object({
    final_date: z.string(),
    // Add other fields as needed based on actual API response
  }),
})

export type SubscribeProtectionResponse = z.infer<typeof subscribeProtectionResponseSchema>

// Unsubscribe Request/Response
export const unsubscribeRequestSchema = z.object({
  subscribeMappId: z.string(),
  unsubsrcibeReason: z.string(),
})

export type UnsubscribeRequest = z.infer<typeof unsubscribeRequestSchema>

export const unsubscribeResponseSchema = z.object({
  resultCd: z.string(),
  resultMsg: z.string().optional(),
  // Add other response fields as needed
})

export type UnsubscribeResponse = z.infer<typeof unsubscribeResponseSchema>
